import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
// import img3 from "./images/laxmilogo.jpg";
// import img4 from "./images/LaxmiHeadingText.jpeg";
import img4 from "./images/LaxmiHeadText1.jpeg";

import { FaBars } from "react-icons/fa";
import { useState } from "react";
function Navbar() {
  const [showLinks, setShowLinks] = useState(false);

  return (
    <>
      <div className="navbarGridContainer">
        <div className="gridItemImg">
          {/* <img src={img3} alt="laxmi" /> */}
          <img src={img4} alt="Laxmi" />
        </div>

        <div className="gridItemHumbergerIcon">
          <div className="navslide">
            <button
              style={{
                backgroundColor: "white",
                border: "none",
                color: "white",
                marginLeft: "75%",
              }}
            >
              <FaBars
                style={{
                  color: "black",
                  backgroundColor: "white",
                  fontSize: "18px",
                }}
                onClick={({ visible }) => {
                  setShowLinks(!showLinks);
                  // if (visible) {
                  //   return <div className="slideInn">slideIn</div>;
                  // } else <div className="slideOutt">slideOut</div>;
                }}
              />
            </button>
            {/*REMOVED IF STATEMNT ADD STYLES*/}
            <div className={`navlinks ${showLinks ? "slideInn" : "slideOutt"}`}>
              <Link to={"./"}>
                <p> HOME</p>
              </Link>
              <Link to={"./Gallery1"}>
                <p> GALLERY</p>
              </Link>
              <Link to={"./Testimonial"}>
                <p>TESTIMONIAL</p>
              </Link>
              <Link to={"./Courses"}>
                <p>COURSES</p>
              </Link>
            </div>
          </div>
        </div>
        <div id="nav-links">
          <Link to={"./"}>HOME</Link>
          <Link to={"./Gallery1"}> GALLERY</Link>
          <Link to={"./Testimonial"}> TESTIMONIAL</Link>
          <Link to={"./Courses"}> COURSES</Link>
        </div>
      </div>
    </>
  );
}
export default Navbar;
